module.exports = __webpack_public_path__ + "static/corporate-6e193f2561c8392d2a552aaba8bd384c.png";